(function Agents($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload(['/Videos/index/', '/Clients/videos'], function onload()
		{
			var $agent_videos     = $('#agent-videos');
			var $franchise_videos = $('#franchise-videos');
			var $global_videos    = $('#global-videos');

			// agent videos
			Adzuki.Ajax.get('/Videos/getVideos/agent')
				.then(function populateAgentVideos(response) {
					$agent_videos.html(response);

					Adzuki.Form.initAjaxForm('AgentVideoCategoryFilter');

					handleShowVideoClick();
				}
			);

			// franchise shared videos
			Adzuki.Ajax.get('/Videos/getVideos/franchise')
				.then(function populateFranchiseVideos(response) {
					$franchise_videos.html(response);

					Adzuki.Form.initAjaxForm('AgentVideoCategoryFilter');

					handleShowVideoClick();
				}
			);

			// global videos
			Adzuki.Ajax.get('/Videos/getVideos/global')
				.then(function populateGlobalVideos(response) {
					$global_videos.html(response);

					Adzuki.Form.initAjaxForm('AgentVideoCategoryFilter');

					handleShowVideoClick();
				}
			);

			// event listener and form init for pagination
			$('body').on('ajax-pagination.loaded', function onAjaxLoaded() {
				Adzuki.Form.initAjaxForm('AgentVideoCategoryFilter');

				handleShowVideoClick();
			});

			// set hidden tab value for category filtering
			$('.video-tab').click(function showVideo(e) {
				var selected = $(this).data('type');

				$('.current-video-tab').val(selected);
			});

			// enable show video click handler
			handleShowVideoClick();

			// silence the audio when the modal is dismissed
			$('#modalWindow').on('hide.bs.modal', function _silenceYouFools() {
				$("#modalWindow iframe").attr("src", '');
				$("#modalWindow audio").attr("src", '');
				$("#modalWindow video").attr("src", '');
				$('#modalWindow').find('.modal-body').html('<iframe frameborder="0"></iframe>');
			});

			$('.video-table').on('change', '.video-actions', function _action() {
				var action     = $(this).val(),
					base_url   = Adzuki.base_uri + '/Videos/',
					video_id   = $(this).data('video-id'),
					public_url = $(this).data('public-url'),
					$self      = $(this),
					$modal     = $(".modal"),
					client_id  = window.location.pathname.split('/').pop();

				switch (action) {
					case 'bucket':
						Adzuki.Buckets.initAddButton($('.video-table #video-public-url-' + video_id));
						$('.video-table #video-public-url-' + video_id).trigger('click');
						$self.get(0).selectedIndex = 0;
						$self.unbind('click');
						break;
					case 'copy':
						copyTextToClipboard(public_url);
						break;
					case 'edit':
						Adzuki.Sidebar.populateRightContentViaAjax(base_url + 'editVideo/' + video_id, 'EditVideo');
						Adzuki.Sidebar.toggleRightSidebar('on');
						break;
					case 'delete':
						Adzuki.CustomConfirm({
							title  : 'Decision Time',
							content: 'Are you sure you want to delete this video?',
							confirm: function confirm() {
								document.location = base_url + 'deleteVideo/' + video_id;
							},
						});
						break;
					case 'download':
						window.open(base_url + 'download/' + video_id);
						break;
					case 'link':
						document.location = base_url + 'linkVideoToClient/' + video_id;
						break;
					case 'send':
						document.location = base_url + 'share/' + video_id;
						break;
					case 'unlink':
						document.location = base_url + 'linkVideoToClient/' + video_id;
						break;
					case 'unlinkClient':
						Adzuki.CustomConfirm({
							title  : 'Decision Time',
							content: 'Removing the client linked to this video will remove this video from the client profile. Would you like to continue?',
							confirm: function confirm() {
								document.location = base_url + 'unlinkClientVideo/' + video_id + '/' + client_id;
							},
						});
						break;
					case 'view':
						$modal.addClass('wide');
						$modal.find('iframe').attr({
							src   : $self.data('iframe-src'),
							height: 500,
							width : '100%'
						});

						$modal.find('.modal-title').text($self.data('title'));
						$modal.on('hidden.bs.modal', function _restoreModal() {
							$modal.removeClass('wide').off('hidden.bs.modal');
						}).modal('show');
						break;
					default:
						break;
				}
			});
		});

		// Function to copy text to the clipboard (iOS)
		function copyTextToClipboard(text) {
			if (navigator.clipboard) {
				navigator.clipboard.writeText(text).then(function _copyToClipboard() {
					Adzuki.StatusMessage('Success', 'The link to the video has been copied to your clipboard.');
				}).catch(function _errorCopyToClipboad(error) {
					Adzuki.StatusMessage('Error', 'Error copying URL to clipboard. Error: ' + error );
				});
			} else {
				// Fallback for browsers that do not support Clipboard API
				let textArea = document.createElement("textarea");
				textArea.value = text;
				// Avoid scrolling to bottom of page in iOS
				textArea.style.position   = "fixed";
				textArea.style.top        = "0";
				textArea.style.left       = "0";
				textArea.style.width      = "2em";
				textArea.style.height     = "2em";
				textArea.style.padding    = "0";
				textArea.style.border     = "none";
				textArea.style.outline    = "none";
				textArea.style.boxShadow  = "none";
				textArea.style.background = "transparent";
				document.body.appendChild(textArea);
				textArea.focus();
				textArea.select();
				try {
					document.execCommand('copy');
					Adzuki.StatusMessage('Success', 'The link to the video has been copied to your clipboard.');
				} catch (err) {
					Adzuki.StatusMessage('Error', 'Error copying URL to clipboard. Error: ' + err);
				}
				document.body.removeChild(textArea);
			}
		}

		function handleShowVideoClick()
		{
			$('.video').on('click', function showVideo(e) {
				var $self          = $(this),
					$modal         = $(".modal"),
					title          = $self.data("title"),
					iframe_src     = $self.data("iframe-src"),
					iframe_height  = $self.data("iframe-height") || 500,
					iframe_width   = $self.data("iframe-width") || '100%';

					e.preventDefault();

				$modal.addClass('wide');

				$modal.find('iframe').attr({
					src   : iframe_src,
					height: iframe_height,
					width : iframe_width
				});

				$modal.find('.modal-title').text(title);
				$modal.on('hidden.bs.modal', function _restoreModal() {
					$modal.removeClass('wide').off('hidden.bs.modal');
				}).modal('show');
			});
		}
	});
}(jQuery, window.Adzuki || {}));
